import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import { Wrapper, AwardImage } from './styles';

const Awards = ({ sectionId, className, data }) => {
  if (!data) return null;
  const { colourOverrideBackground, titleHtml, width, items } = data;
  return (
    <Wrapper
      id={sectionId}
      className={[className, width, 'awards-banner']}
      colourOverrideBackground={colourOverrideBackground}
    >
      {ReactHtmlParser(titleHtml)}
      <ul>
        {items.map(({ image, imageSharp }, index) => {
          return (
            <li key={`awards-${image.url}-${index.toString()}`}>
              <AwardImage src={imageSharp || image.url} alt={image.altTag} />
            </li>
          );
        })}
      </ul>
    </Wrapper>
  );
};

Awards.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape().isRequired,
  sectionId: PropTypes.string.isRequired,
};

Awards.defaultProps = {
  className: null,
};

export default Awards;
